export default {
    main_page: {
        header: {
            position_lite_btn: '포지션 찾기 Lite',
            position_pro_btn: '포지션 찾기 PRO',
            title: {
                lite: '무료 축구 포지션 찾기 Lite',
                pro: '더 전문적인 포지션 찾기 PRO'
            },
            sub_title: {
                lite: '진짜 내가 잘할 수 있는 포지션이 궁금하지 않으세요?<br>단 몇 가지 대답으로 나에게 어울리는 축구 포지션을 찾아보세요',
                pro: '전문가가 추천하는 내 축구 포지션이 궁금하신가요?<br>심층적인 질문과 답변으로 한층 더 디테일하게 내 포지션을 찾으세요',
            }
        },
        body: {
            total_find_position_cnt: '지금까지 찾은 축구 포지션',
            today_find_position_cnt: '오늘 찾은 포지션',
            test_pee: '테스트 비용',
            most_position_cnt: '가장 많은 포지션',
            lite_text: {
                title: '포지션 찾기 Lite',
                sub_title1: '축구 포지션에 대한 정확도 높은 데이터를 바탕으로 제작된 사커하우만의 포지션 찾기입니다. 오직 사커하우에서만 할 수 있죠.',
                sub_title2: '몇 분도 안 걸리는 시간을 내어 회원님의 축구 포지션을 찾아보세요. 버튼만 누르다보면 어느새 회원님에게 맞는 포지션 결과가 완성됩니다!',
                gk_explanation: '골키퍼(GK)는 포지션 찾기 PRO를 통해서만 찾을 수 있습니다.'
            },
            pro_text: {
                title: '포지션 찾기 PRO',
                sub_title1: '포지션 찾기 PRO는 약 200명의 프로 축구선수들과 전문 코치, 여러 프로 축구팀을 통해 얻은 포지션 찾기 데이터를 바탕으로 제작되었습니다.',
                sub_title2: '모든 질문에 신중해지세요. 그리고 객관적인 선택을 해주세요.',
                explanation1: '포지션 찾기 lite보다 한층 더 전문적인 피드백을 제공합니다.',
                explanation2: '회원님의 축구 능력치를 분석해서 그래프로 표시합니다.',
                explanation3: '축구를 하면서 벌어지는 여러 상황들 등 디테일한 질문들을 추가하여 테스터의 성향을 면밀히 파악할 수 있습니다.',
                explanation4: '포지션 찾기 특허를 출원했습니다.',
            },
            common_text: {
                box1: '본인의 운동 능력을 기준으로 답해주세요. 축구팀이 있다면 팀에서의 운동 능력을 기준으로 해주세요.',
                box2: '보다 정확한 포지션 찾기 결과를 제공받기 위해서는 확실한 측정치에 체크해야 합니다.',
                box3: '축구 MBTI처럼 진행하시면 됩니다.',
                position_info: '포지션 정보',
                explanation: '포지션 정보는 4-4-2 포메이션을 기반으로 제공됩니다. 전술에 따라 유동성이 있는 포지션의 명칭은 제외하며, 가장 대표적인 포지션만 적용됩니다.',
            },
            position_list: {
                attacker: '공격',
                midfielder: '미드필더',
                defender: '수비',
                goalKeeper: '골키퍼',
                cf: {
                    name: '중앙 공격수',
                    position: 'CF'
                },
                ss: {
                    name: '세컨드 스트라이커',
                    position: 'SS'
                },
                wf: {
                    name: '윙 포워드',
                    position: 'LWF / RWF'
                },
                am: {
                    name: '공격형 미드필더',
                    position: 'AM'
                },
                cm: {
                    name: '중앙 미드필더',
                    position: 'CM'
                },
                dm: {
                    name: '수비형 미드필더',
                    position: 'DM'
                },
                mf: {
                    name: '측면 미드필더',
                    position: 'LM / RM'
                },
                cb: {
                    name: '중앙 수비수',
                    position: 'CB'
                },
                fb: {
                    name: '풀백',
                    position: 'LB / RB'
                },
                wb: {
                    name: '윙백',
                    position: 'LWB / RWB'
                },
                gk: {
                    name: '골키퍼',
                    position: 'GK'
                }
            }
        },
        footer: {
            title1: '사커하우 APP 다운로드하기',
            title2: '개인정보 보호 정책',
            title3: '문의'
        }
    }
};